import Chat from './Chat';

const showChat = import.meta.env.CLIENT_SHOW_CHAT_UNAUTHENTICATED === 'true';

const ChatUnaut = () => showChat && <Chat className="absolute bottom-0 left-0 m-4 !p-0 [&_button]:!size-16" />

export default ChatUnaut;
